import type { CommandData } from '../types'

export function unmount() {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'unmount',
  }
  window.postMessage(message)
}
